import React, { Fragment, useEffect, useState } from "react";
import { RegisterLabels } from "../../assets/labels/labels";
import { IconCheck, IconClient } from "../../assets/svgs-index";
import { useLocation, useNavigate } from "react-router-dom";
import PoweredBy from "../../components/PoweredBy/PoweredBy";
import { AuthenticationService } from "../../core/services/authentication.service";
import ModalInformation from "../../components/Modals/ModalInformation";
import Cookies from "universal-cookie";
import { Helper } from "../../core/services/helper/helper.service";
import { CompanyService } from "../../core/services/company.service";

const SendConfirmEmail: React.FC<any> = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [email] = useState<string>(searchParams.get("email") || location?.state?.email);
  const open_appointment = location?.state?.openAppointment || cookies.get("openAppointment");
  const domain = location?.state?.domain || cookies.get("kssreturncompany")?.replace(".qa", "");

  const [modalInfoIsOpen, setModalInfoIsOpen] = useState<boolean>(false);
  const [modalInfoTitle, setModalInfoTitle] = useState<string>("");
  const [modalInfoMessage, setModalInfoMessage] = useState<string>("");
  const [modalInfoSubMessage] = useState<string>("");
  const [modalInfoConfirmText, setModalInfoConfirmText] = useState<string>("");
  const [modalInfoOnConfirm, setModalInfoOnConfirm] = useState<() => void>();
  const isEmbedded = Helper.isEmbedded();
  const [isTokenError, setIsTokenError] = useState<boolean>(location?.state?.isTokenError || false);  //Apresentação distinta quando esta página é de erro.

  useEffect(() => {
    if(!email) {
      const path = '/registo';
      navigate(`${path}${isEmbedded ? '?embedded=true' : ''}`);


    }
    // eslint-disable-next-line 
  }, [email, navigate]);

  const handleSubmit = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    let body: { email: string; user_id?: string; work_token?: string; domain?: string; work_email?: string; work_phone?: string; open_appointment?: boolean; is_cal_token?: string; embedded?:string; } = {
      email,
      
    };
    if (location.state?.userId ||cookies.get("userId")) {
      body = {
        ...body,
        user_id: location.state?.userId || cookies.get("userId"),
        domain: domain,
        work_token: location.state?.liteToken || cookies.get("liteToken"),
        work_email: location.state?.liteEmail || cookies.get("liteEmail"),
        work_phone: location.state?.litePhone || cookies.get("litePhone"),
        is_cal_token: location.state?.isCalToken || cookies.get("isCalToken"),
      };
    } else {
      if (domain !== null) {
        body = {
          ...body,
          domain: domain,
        };
      }
    }
    if (open_appointment) {
      body = {
        ...body,
        open_appointment: open_appointment,
      }
    }
    if (isEmbedded) {
      body = {
        ...body,
        embedded: "true",
      }
    }
    AuthenticationService.sendEmailConfirmation(body, navigate, undefined , isEmbedded? 'true' : undefined).then((res) => {
      if (res) {
        setModalInfoTitle(res.title);
        setModalInfoMessage(res.message);
        setModalInfoConfirmText(res.confirmText);
        res.onConfirm === "navigate" && setModalInfoOnConfirm(() => handleSendNewEmail);
        setModalInfoIsOpen(true);
        setIsTokenError(false);
      }
    });
  };

  const handleSendNewEmail = () => {
    closeModal();
    const state = {
      email,
      userId: location.state?.userId || cookies.get("userId"),
      domain: cookies.get("kssreturncompany")?.replace(".qa", ""),
      liteToken: location.state?.liteToken || cookies.get("liteToken"),
      liteEmail: location.state?.liteEmail || cookies.get("liteEmail"),
      litePhone: location.state?.litePhone || cookies.get("litePhone"),
      isCalToken: location.state?.isCalToken || cookies.get("isCalToken"),
      openAppointment: open_appointment,
    };
    //navigate("/send-confirm-email", { state });
    navigate(`/send-confirm-email${isEmbedded ? '?embedded=true' : ''}`, { state });

  };

  const renderModalInformation = (handler: any) => {
    if (!modalInfoIsOpen) {
      return <Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={modalInfoIsOpen}
        title={modalInfoTitle}
        message={modalInfoMessage}
        subMessage={modalInfoSubMessage}
        confirmText={modalInfoConfirmText}
        onClose={() => closeModal()}
        onConfirm={handler || closeModal}
      />
    );
  };

  const goToLogin = (
    state = {
      email,
      userId: location.state?.userId || cookies.get("userId"),
      domain: cookies.get("kssreturncompany")?.replace(".qa", ""),
      liteToken: location.state?.liteToken || cookies.get("liteToken"),
      liteEmail: location.state?.liteEmail || cookies.get("liteEmail"),
      litePhone: location.state?.litePhone || cookies.get("litePhone"),
      isCalToken: location.state?.isCalToken || cookies.get("isCalToken"),
    }
  ) => {
    navigate(`/login${isEmbedded ? '?embedded=true' : ''}`, {state,});
  };

  const closeModal = () => {
    setModalInfoIsOpen(false);
    setModalInfoTitle("");
    setModalInfoMessage("");
    setModalInfoConfirmText("");
    setModalInfoOnConfirm(undefined);
  };

  const renderEmbeddedHeader = () => {
    return (
      <>
        <div className="header w-100 d-flex flex-row justify-content-between ps-md-9 opacity-50">
          <div className="logo-container d-flex flex-column">
            <div className="company-logo mt-2 mx-3 mx-md-4">
              <img className="kmclient-logo"
              src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
              alt="logo"
              onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
            </div>
          </div>
          <div className="app-logo-container me-3 me-md-4 align-items-center">
            {" "}
            <PoweredBy isTop={true}/>
          </div>
        </div>
      </>
    )
  }

  const containerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // semi-transparent background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000, // Ensure it's on top of other elements
    maxWidth: 'none',

  };

  const iframeContainerStyle = {
    width: '96%',
    height: '200%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    //overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
  };

  const embeddedContainerStyle = isEmbedded ? containerStyle : {};
  const embeddedIframeContainerStyle = isEmbedded ? iframeContainerStyle : {};

  return (
    <React.Fragment>
      <div className={`main-page-container pb-4 h-100 pt-0 align-center justify-content-start ${isEmbedded ? 'mt-0 ' : 'mt-4 container'}`} style={embeddedContainerStyle}>
        {!isEmbedded &&
          <>
            <div className="company-logo-container mt-2 mt-md-4" onClick={() => navigate("/")}>
              <img className="kmclient-logo" src={IconClient} alt="logo" />
            </div>
          </>
        }
        {isEmbedded && renderEmbeddedHeader()}
        {isEmbedded ? (
          <div style={embeddedIframeContainerStyle}>
            <h3 className="text-center w-100 my-4">{RegisterLabels.sendConfirmEmailInfo.header}</h3>

            <div className="grey-box-container align-center py-4 px-6 w-100">
              <h3 className="text-center w-100 mt-3"> {isTokenError ? RegisterLabels.sendConfirmEmailInfo.text_token_error : RegisterLabels.sendConfirmEmailInfo.title}</h3>
              {!isTokenError &&
                <>
                  <div className="text-center message-container mt-4">
                    (<><b>{RegisterLabels.sendConfirmEmailInfo.text_1} </b>{" "}
                      {RegisterLabels.sendConfirmEmailInfo.text_2} <b> {email}</b></>)
                  </div>
                  <div className="check-icon-container mt-5 mb-2">
                    <img src={IconCheck} alt="" />
                  </div>
                  <div className="text-center message-container mt-4 align-center">
                    {" "}
                    {RegisterLabels.sendConfirmEmailInfo.link_1}
                    <div className="link-container mt-0" onClick={() => goToLogin()}>
                      Inicie sessão aqui!
                    </div>
                  </div>
                </>
              }
              <div className="text-center message-container mt-4">
                <div onClick={handleSubmit} className="link-container large">
                  {" "}
                  {isTokenError ? RegisterLabels.sendConfirmEmailInfo.link_error_send_again : RegisterLabels.sendConfirmEmailInfo.link_2}{" "}
                </div>
              </div>
              <div>
                <b>({RegisterLabels.sendConfirmEmailInfo.text_1})</b>
              </div>
            </div>
          </div>)
          :
          <>
            <h3 className="text-center w-100 my-4">{RegisterLabels.sendConfirmEmailInfo.header}</h3>

            <div className="grey-box-container align-center py-4 px-6 w-100">
              <h3 className="text-center w-100 mt-3"> {isTokenError ? RegisterLabels.sendConfirmEmailInfo.text_token_error : RegisterLabels.sendConfirmEmailInfo.title}</h3>
              {!isTokenError &&
                <>
                  <div className="text-center message-container mt-4">
                    (<><b>{RegisterLabels.sendConfirmEmailInfo.text_1} </b>{" "}
                      {RegisterLabels.sendConfirmEmailInfo.text_2} <b> {email}</b></>)
                  </div>
                  <div className="check-icon-container mt-5 mb-2">
                    <img src={IconCheck} alt="" />
                  </div>
                  <div className="text-center message-container mt-4 align-center">
                    {" "}
                    {RegisterLabels.sendConfirmEmailInfo.link_1}
                    <div className="link-container mt-0" onClick={() => goToLogin()}>
                      Inicie sessão aqui!
                    </div>
                  </div>
                </>
              }
              <div className="text-center message-container mt-4">
                <div onClick={handleSubmit} className="link-container large">
                  {" "}
                  {isTokenError ? RegisterLabels.sendConfirmEmailInfo.link_error_send_again : RegisterLabels.sendConfirmEmailInfo.link_2}{" "}
                </div>
              </div>
              <div>
                <b>({RegisterLabels.sendConfirmEmailInfo.text_1})</b>
              </div>
            </div>
            <div className="powered-by-container mt-4 w-100">
              {" "}
              <PoweredBy />
            </div>
          </>
        }
        {renderModalInformation(modalInfoOnConfirm)}
      </div>
    </React.Fragment>
  );
};

export default SendConfirmEmail;
